// @ts-nocheck
import { lazy } from 'react';
export const DedicatedChatScreenAsync = lazy(
  () => import('./DedicatedChatScreen.tsx'),
);
